// extracted by mini-css-extract-plugin
export default {"swiper":"swiper-pagination-module--swiper--9e708","navigationDot":"swiper-pagination-module--navigation-dot--cc196"};